import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import media from '../../styled/media';

export const StyledSlider = styled(Slider)`
  .slick-prev,
  .slick-next {
    z-index: 1;
    width: 48px;
    height: 48px;
    background: url('/images/home/arrow.svg') no-repeat center !important;
    transform: none;
    &:hover {
      opacity: 0.8;
    }
    &:before {
      display: none;
    }
  }
  .slick-prev {
    left: 0;
    transform: translate(0, -50%);
    ${media.tablet`
      left: 48px;
    `}
  }
  .slick-next {
    right: 0;
    transform: translate(0, -50%) rotate(180deg);
    ${media.tablet`
      right: 48px;
    `}
  }
  .slick-slide {
    visibility: hidden;
  }
  .slick-active {
    visibility: visible;
    z-index: 1;
  }
`;
